/* global window */

import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { showLogin, logout } from 'components/login/actions';

class SideNav extends React.Component {
  componentDidMount() {
    this.slideout();
  }

  slideout() {
    if (!window.Slideout) return;

    var slideout = new window.Slideout({
      panel: document.getElementById('panel'),
      menu: document.getElementById('menu'),
      side: 'left'
    });

    document
      .querySelector('.js-slideout-toggle')
      .addEventListener('click', function() {
        slideout.toggle();
      });

    document.querySelector('.menu').addEventListener('click', function(eve) {
      if (eve.target.nodeName === 'A') {
        slideout.close();
      }
    });

    slideout.on('beforeopen', function() {
      document
        .querySelector('.slideout-panel')
        .classList.add('slideout-panel-open');
    });

    slideout.on('beforeclose', function() {
      document
        .querySelector('.slideout-panel')
        .classList.remove('slideout-panel-open');
    });
  }

  render() {
    return (
      <nav id="menu" className="menu slideout-menu">
        {!this.props.user && (
          <header className="menu-header">
            <a href="/signup" className="menu-header-title menu-header-link">
              <i className="fa fa-user" />Sign up
            </a>
            <a href="/login" className="menu-header-title menu-header-link">
              Login
            </a>
          </header>
        )}
        <section className="menu-section">
          <h3 className="menu-section-title">Shop</h3>
          <ul className="menu-section-list">
            <li>
              <Link to="/beer">Beer</Link>
            </li>
            <li>
              <Link to="/wine">Wine</Link>
            </li>
            <li>
              <Link to="/spirits">Spirits</Link>
            </li>
            <li>
              <Link to="/mixers">Mixers</Link>
            </li>
            <li>
              <Link to="/more">More</Link>
            </li>
            <li>
              <Link to="/gifting">Gifts</Link>
            </li>
            <li>
              <a href="/bartenders">Book a Bartender</a>
            </li>
          </ul>
        </section>
        {!!this.props.user && (
          <section className="menu-section">
            <h3 className="menu-section-title">
              <a href="/account">Your Account</a>
            </h3>
          </section>
        )}
        <section className="menu-section">
          <h3 className="menu-section-title">
            <a href="/blog">Blog</a>
          </h3>
        </section>
        <section className="menu-section">
          <h3 className="menu-section-title">
            <a href="http://help.sauceyapp.com/">Support</a>
          </h3>
        </section>
        {!!this.props.user && (
          <section className="menu-section">
            <span
              onClick={this.props.logout.bind(this)}
              className="menu-header-title"
            >
              <h3 className="menu-section-title">Logout</h3>
            </span>
          </section>
        )}
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.login };
}

export default connect(mapStateToProps, { showLogin, logout })(SideNav);



// WEBPACK FOOTER //
// ./shared/components/sideNav/index.js